<ng-template let-context let-modal="modal" #modalTemplate>
    <div class="header">
        <div class="ui grid desktop">
            <div *ngIf="confirmed" class="ui eight wide column">
                <h3>Location validée !</h3>
            </div>
            <div *ngIf="!confirmed" class="ui eight wide column">
                <h3>Réservation de votre location</h3>
            </div>
            <div *ngIf="!confirmed" class="ui five wide column" >
                <p class="available-location">Nombre de véhicules disponibles: {{nbVans}}</p>
            </div>
            <div *ngIf="!confirmed" class="ui three wide column">
                <button class="ui icon button arrow-button location-selection button-selection-left" (click)="previousVan()">
                    <i class="arrow left icon"></i>
                </button>
                <p class="available-location location-selection">{{currentVan.Position()}}</p>
                <button class="ui icon button arrow-button location-selection button-selection-right" (click)="nextVan()">
                    <i class="arrow right icon"></i>
                </button>
            </div>
        </div>
        <div class="ui grid smartphone">
            <div *ngIf="confirmed" class="ui eight wide column">
                <h3>Location validée !</h3>
            </div>
            <div *ngIf="!confirmed" class="ui eight wide column" >
                <p class="available-location">Véhicules disponibles: {{nbVans}}</p>
            </div>
            <div *ngIf="!confirmed" class="ui eight wide column">
                <button class="ui icon button arrow-button location-selection button-selection-left" (click)="previousVan()">
                    <i class="arrow left icon"></i>
                </button>
                <p class="available-location location-selection">{{currentVan.Position()}}</p>
                <button class="ui icon button arrow-button location-selection button-selection-right" (click)="nextVan()">
                    <i class="arrow right icon"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="content">
        <div *ngIf="!confirmed">
            <leasing-userCalendar [calendar]="calendar" (slotSelected)="onSlotSelected()" (slotUnSelected)="onSlotSelected()"></leasing-userCalendar>
            <leasing-user></leasing-user>
        </div>
        <div *ngIf="confirmed" [@enterAnimation] class="confirmation-box">
            <img class="ui medium image van-img" src={{currentVan.Value().leasing.picture}}>
            <p class="confirmation-p">Votre location d'un véhicule <b>{{currentVan.Value().leasing.name}}</b>
                                      a bien été prise en compte !
            </p>
            <p class="confirmation-p">Votre réservation est en attente de validation par le garage.
                Vous recevrez un email lorsque celle-ci aura été approuvée.
            </p>
            <p class="confirmation-p">
                Pour toute modification ou annulation de votre location. Merci de contacter le garage par mail ou par téléphone.
            </p>
        </div>

    </div>
    <div class="actions">
        <div class="ui equal width grid">
            <div class="ui column price-container desktop">
                <p class="price">Estimation du prix: {{priceEstimation}}€</p>
            </div>
            <div class="ui column price-container desktop">
                <div class="ui range" id="my-range"></div>
                <p class="price">{{nbKm}} km</p>
            </div>
            <div class="ui column calendar-buttons">
                <div *ngIf="!confirmed">
                    <button class="ui button" (click)="cancel(modal)">Annuler</button>
                    <button class="ui primary button" (click)="book()" autofocus>{{bookButtonLabel()}}</button>
                </div>
                <div *ngIf="confirmed">
                    <button class="ui button" (click)="cancel(modal)">Ok</button>
                </div>
            </div>
        </div>
    </div>
    <error-popup></error-popup>
</ng-template>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/userReservationEdit.html